import { atom } from 'jotai';
import { createInfluencerAtom } from '../influencer';
import { variablesAtom } from '../config';

export const variableMapAtom = atom((get) => ({
	'influencer.name':
		get(createInfluencerAtom).data?.name ||
		get(createInfluencerAtom).data?.email ||
		'Guest',
	'product.name': get(variablesAtom).productName,
	'product.url': get(variablesAtom).productURL,
	promocode: get(variablesAtom).promocode,
}));
